import { IApi } from "./IApi";
import { BasicAPI } from "./implementations/BasicAPI";

export const crmAPI: IApi = new BasicAPI(import.meta.env.VITE_CRM_API);
export const crmSocketAPI = new BasicAPI(import.meta.env.VITE_CRM_SOCKET_API);
